import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function PebbleMosaicPage() {
  return <ProductPageContent data={PRODUCT_PAGES["pebble-mosaic"]} />;
}

export default PebbleMosaicPage;
